
import React from 'react';

const GameHero = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="relative z-10 py-8 sm:py-16 px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl mb-4">
              <span className="block text-yellow-400">Pokemon Clicker 2</span>
              <span className="block text-white text-3xl sm:text-4xl mt-2">The Ultimate Free Online Clicking Adventure</span>
            </h1>
            <p className="max-w-3xl mx-auto text-xl text-gray-300">
              Catch, evolve, and collect Pokemon in this addictive clicking game. 
              Build your dream team and become the ultimate Pokemon master!
            </p>
            <div className="mt-10">
              <a href="#play" className="inline-block bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-3 px-8 rounded-full transition duration-300 transform hover:scale-105 shadow-lg">
                Play Now - It's Free!
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 z-0">
        <svg className="h-full w-full" viewBox="0 0 1200 800" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <defs>
            <radialGradient id="pokeball-gradient" cx="50%" cy="50%" r="70%" fx="50%" fy="50%">
              <stop offset="0%" stopColor="#ff0000" stopOpacity="0.7" />
              <stop offset="45%" stopColor="#ff0000" stopOpacity="0.2" />
              <stop offset="50%" stopColor="#ffffff" stopOpacity="0.3" />
              <stop offset="55%" stopColor="#000000" stopOpacity="0.2" />
              <stop offset="100%" stopColor="#000066" stopOpacity="0.1" />
            </radialGradient>
          </defs>
          <circle cx="600" cy="400" r="350" fill="url(#pokeball-gradient)" />
          <path d="M300,400 H900" stroke="rgba(0,0,0,0.5)" strokeWidth="20" />
          <circle cx="600" cy="400" r="70" fill="rgba(255,255,255,0.7)" stroke="rgba(0,0,0,0.5)" strokeWidth="10" />
          <circle cx="600" cy="400" r="35" fill="rgba(255,255,255,1)" stroke="rgba(0,0,0,0.8)" strokeWidth="10" />
        </svg>
      </div>
    </div>
  );
};

export default GameHero;
